export default "__VITE_ASSET__B6sw2uwh__"